import Duration from "dayjs/plugin/duration";
import React from "react";
import dayjs, { Dayjs } from "dayjs";

dayjs.extend(Duration);

type TimerProps = {
  date: string | Date | Dayjs;
  className?: string;
};

export const Timer = ({
  date,
  className = "",
}: TimerProps): React.ReactElement => {
  const getDifference = React.useCallback(() => {
    const { d, h, m, s } = {
      d: dayjs().diff(dayjs(date), "day"),
      h: dayjs().diff(dayjs(date), "hour") % 24,
      m: dayjs().diff(dayjs(date), "minute") % 60,
      s: dayjs().diff(dayjs(date), "second") % 60,
    };

    return `${d > 0 ? `${d}d` : ""} ${h > 0 ? `${h}h` : ""} ${
      m > 0 ? `${m}m` : ""
    } ${s > 0 ? `${s}s` : ""}`;
  }, [date]);
  const [time, setTime] = React.useState(getDifference());

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(getDifference());
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [getDifference]);

  return <span className={className}>{time}</span>;
};
